import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { Sport } from '../../../typings/motorsports';
import {
  RACE,
  RACE_SPRINT,
  RACE_STATUS_FIXTURE,
  RACE_STATUS_PLAYED,
  RACE_STATUS_PLAYING,
  RaceSessionStatus,
  RaceSessionType,
} from '../../../typings/race-session';
import { CIRCUITTRACKWHITE, placeholdersMap } from '../../../utils/placeholders-motorsports';
import { makeClassNames } from '../../../utils/styles';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import LgpHeader from '../../molecules/lgp-header/lgp-header';
import Podium, { PodiumItem } from '../../molecules/podium/podium';
import TopThree, { TopThreeItem } from '../../molecules/top-three/top-three';

import './lgp-hero.scss';

export interface ILgpHero extends IComponent {
  sportTag: Sport;
  sessionStatus: RaceSessionStatus;
  sessionName: RaceSessionType;
  flagImgUrl: string;
  customGpName: string;
  startDate: string;
  endDate: string;
  circuitImgUrl?: string;
  podium: PodiumItem[] | TopThreeItem[];
}

const classNames = () =>
  makeClassNames({
    lgpHero: 'lgp-hero',
    lgpHeroTitle: 'lgp-hero__title',
    lgpHeroFlag: 'lgp-hero__flag',
    lgpHeroDates: 'lgp-hero__dates',
    lgpHeroCircuit: 'lgp-hero__circuit',
    lgpHeroPodium: 'lgp-hero__podium',
    lgpHeroTopThree: 'lgp-hero__top-three',
  });

const LgpHero = ({
  sessionStatus,
  sessionName,
  flagImgUrl,
  customGpName,
  startDate,
  endDate,
  circuitImgUrl,
  podium,
  sportTag,
}: ILgpHero) => {
  const cn = classNames();

  return (
    <div className={cn.lgpHero}>
      <LgpHeader
        sportTag={sportTag}
        flagImgUrl={flagImgUrl}
        customGpName={customGpName}
        startDate={startDate}
        endDate={endDate}
        sessionName={sessionName}
        sessionStatus={sessionStatus}
      />
      {[RACE_STATUS_FIXTURE, RACE_STATUS_PLAYING].includes(sessionStatus!) && (
        <div className={cn.lgpHeroCircuit}>
          <ImgPlaceholder
            placeholder={placeholdersMap[CIRCUITTRACKWHITE]}
            src={circuitImgUrl}
            alt={`Circuito ${customGpName}`}
          />
        </div>
      )}
      {sessionStatus === RACE_STATUS_PLAYED && [RACE, RACE_SPRINT].includes(sessionName) && (
        <div className={cn.lgpHeroPodium}>{<Podium podium={podium as PodiumItem[]} />}</div>
      )}
      {sessionStatus === RACE_STATUS_PLAYED && ![RACE, RACE_SPRINT].includes(sessionName) && (
        <div className={cn.lgpHeroTopThree}>
          <TopThree topThree={podium as TopThreeItem[]} />
        </div>
      )}
    </div>
  );
};

export default LgpHero;
